import clsx from 'clsx'
import { useMemo } from 'preact/hooks'
import { useSwatches } from '@/components/hooks/useSwatches'

export function ResultsSwatches({ result, swatches, onSelectSwatch }) {
  if (!swatches || swatches.length === 0) return null

  return (
    <>
      <div className="flex flex-wrap gap-x-0.5 gap-y-0.25">
        {swatches.slice(0, 4).map((swatch) => {
          return (
            <Swatch
              key={swatch.handle}
              swatch={swatch}
              onSelectSwatch={onSelectSwatch}
              isCurrentSwatch={swatch.handle === result.handle}
            />
          )
        })}
        {swatches.length > 4 && (
          <span className="text-xs text-neutral-secondary">+{swatches.length - 4}</span>
        )}
      </div>
    </>
  )
}

function Swatch({ swatch, onSelectSwatch, isCurrentSwatch }) {
  function handleClick() {
    onSelectSwatch(swatch.handle)
  }

  const colour = useMemo(() => {
    const tag = swatch?.tags?.find((tag) => tag.includes('Hex'))
    if (!tag) return 'var(--colour-accent)'

    return tag.split('-').pop()
  }, [swatch])

  const isLightColour = useMemo(() => {
    const hexColour = colour.toLowerCase()
    return !hexColour || hexColour === '#ffffff' || hexColour === '#fff' || hexColour === 'white'
  }, [colour])

  const criteria = useMemo(() => ({
    tags: swatch?.tags ?? []
  }), [swatch?.tags])

  const altSwatch = useSwatches(criteria)

  return (
    <button
      className="group/swatch relative shrink-0 flex items-center justify-center py-0.25 after:content-[''] after:absolute after:top-0 after:-left-0.25 after:w-[calc(100%+0.5rem)] after:h-full"
      onClick={handleClick}
      aria-label="View product"
      data-dl-track="toggle_variant"
      data-dl-product-id={swatch.productLegacyResourceId}
      data-dl-attribute="item_colour"
      data-dl-value={swatch.colourName}
    >
      <div
        className={clsx('shrink-0 flex size-1 bg-[--bg-colour] border border-neutral-medium outline outline-1 outline-transparent outline-offset-0 rounded-full overflow-hidden transition-all', isCurrentSwatch ? '!outline-brand-black' : 'group-hover/swatch:outline-neutral-medium')}
        style={{
          '--bg-colour': altSwatch.length > 0 && altSwatch[0].background_colour ? altSwatch[0].background_colour : colour,
          ...(isLightColour && { boxShadow: 'inset 0px 0px 0px 1px var(--darkGrey)' })
        }}
      >
        {altSwatch.length > 0 && altSwatch[0].image && (
          <img
            src={altSwatch[0].image}
            alt="Product swatch"
            className="size-full object-cover"
          />
        )}
      </div>
    </button>
  )
}
